import { starsFor } from '@shared/game/heat';

// Параметры визуальных эффектов. Случайность передаётся снаружи — так формы можно проверить юнит-тестом.
export type Rnd = () => number;

export interface ConfettiPiece {
  /** Горизонтальная позиция старта, % ширины экрана. */
  x: number;
  /** Ширина, px (высота в CSS = 1.6 ширины). */
  w: number;
  /** Задержка и длительность падения, с. */
  delay: number;
  time: number;
  /** Боковой снос и вращение к концу падения. */
  dx: number;
  rot: number;
  color: string;
}

export interface Ember {
  dx: number;
  dy: number;
  size: number;
  delay: number;
  color: string;
}

export const CONFETTI_COLORS = ['#3af0a5', '#ffd23f', '#ff5fb5', '#8f7bff', '#38dcff', '#ff8a3a'] as const;
export const EMBER_COLORS = ['#ffd34d', '#ff8a3a', '#ff4d4d', '#fff1b8'] as const;

const between = (rnd: Rnd, min: number, max: number): number => min + rnd() * (max - min);
const pick = <T>(rnd: Rnd, list: readonly T[]): T => list[Math.floor(rnd() * list.length) % list.length] as T;

export function makeConfetti(count: number, rnd: Rnd = Math.random): ConfettiPiece[] {
  return Array.from({ length: count }, () => ({
    x: between(rnd, 0, 100),
    w: between(rnd, 6, 11),
    delay: between(rnd, 0, 0.9),
    time: between(rnd, 2.1, 3.4),
    dx: between(rnd, -90, 90),
    rot: between(rnd, -720, 720),
    color: pick(rnd, CONFETTI_COLORS),
  }));
}

/** Угольки взрыва разлетаются равномерно по кругу, с небольшим разбросом дальности. */
export function makeEmbers(count: number, rnd: Rnd = Math.random): Ember[] {
  return Array.from({ length: count }, (_, k) => {
    const angle = (k / count) * Math.PI * 2 + between(rnd, -0.2, 0.2);
    const dist = between(rnd, 110, 260);
    return {
      dx: Math.round(Math.cos(angle) * dist),
      dy: Math.round(Math.sin(angle) * dist),
      size: Math.round(between(rnd, 4, 10)),
      delay: between(rnd, 0, 0.12),
      color: pick(rnd, EMBER_COLORS),
    };
  });
}

/** Ступень звёзд, которая ещё достижима при текущем нагреве (для подсветки на шкале): 3, 2 или 1. */
export const tierOf = (heat: number): 1 | 2 | 3 => starsFor('win', heat) as 1 | 2 | 3;
